import { render, staticRenderFns } from "./RegisterIcon.vue?vue&type=template&id=6dbc86a6"
import script from "./RegisterIcon.vue?vue&type=script&lang=ts"
export * from "./RegisterIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports